<template>
  <div class="content">
    <!-- 操作 -->
    <div class="operate-group">
      <div class="operate-group-left">
        <el-button type="primary" @click="add">
          <el-icon>
            <Plus />
          </el-icon>
          <span>{{ t('user.add_aksk') }}</span>
        </el-button>
        <!--更多操作-->
        <el-dropdown trigger="click" class="margin-l2">
          <el-button>
            {{ t('table.moreHandle') }}
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- 编辑 -->
              <el-dropdown-item :disabled="checkedRows.length !== 1" @click.native="editFun">
                <svg-icon icon-class="modify" class="stroke"/>
                {{ t('table.modify') }}
              </el-dropdown-item>
              <!-- 查看Secret -->
              <el-dropdown-item :disabled="checkedRows.length !== 1" @click.native="lookSecretFun">
                <svg-icon icon-class="view" class="stroke"/>
                {{ t('user.secret') }}
              </el-dropdown-item>
              <!-- 启用 -->
              <el-dropdown-item :disabled="checkedRows.length !== 1 || checkedRows[0].status === 'enabled'" divided @click.native="editeStatusFun">
                <svg-icon icon-class="enable" class="stroke"/>
                {{ t('table.enable') }}
              </el-dropdown-item>
              <!-- 禁用 -->
              <el-dropdown-item :disabled="checkedRows.length !== 1 || checkedRows[0].status === 'disabled'" @click.native="editeStatusFun">
                <svg-icon icon-class="disable" class="stroke"/>
                {{ t('table.disable') }}
              </el-dropdown-item>
              <!-- 删除 -->
              <el-dropdown-item :disabled="checkedRows.length !== 1 " divided class="emphasize" @click.native="delFun">
                <svg-icon icon-class="release" class="stroke"/>
                {{ t('table.delete') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="operate-group-right">
        <search-toolbar
          v-model:quick-field="quickSearchField"
          v-model:quick-value="quickSearchValue"
          :quick-fields="quickSearchFields"
          :default-quick-field="defaultQuickField"
          :search-mode="searchMode"
          :filter-summary="filterStr"
          :advanced-button-text="advancedFilterButtonText"
          :choose-placeholder="t('placeholder.choose')"
          :search-placeholder="t('placeholder.search')"
          :refresh-text="t('table.refresh')"
          @quick-field-change="handleQuickFieldChange"
          @quick-value-change="handleQuickValueChange"
          @quick-input="handleQuickInput"
          @open-advanced="openAdvancedDrawer"
          @reset-search="resetAllSearch"
          @refresh="getList" />
      </div>
    </div>
    <!-- 表格 -->
    <custom-table
      v-model:checkedRows="checkedRows"
      :height="$store.getters.windowHeight - 300 < 200 ? 200 : $store.getters.windowHeight - 300"
      :isShowCheck="true"
      :tableData="tableData"
      @getTableData="getList" />
    <!-- 编辑aksk -->
    <addAKSK v-model:add-layer="addLayer" :editType="eidtType" :row="rowData" @getList="getList">
    </addAKSK>
    <!-- 查看Sectet -->
    <lookSectet v-model:layer="lookLayer" :row="rowData">
    </lookSectet>
    <advanced-filter-drawer
      v-model:visible="advancedDrawerVisible"
      :title="advancedFilterButtonText"
      width="50%"
      :has-other-condition="false"
      :filter-condition="advancedFilterCondition"
      :other-condition-list="advancedOtherConditionList"
      @submit="handleAdvancedSubmit"
      @cancel="handleAdvancedCancel" />
  </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import AdvancedFilterDrawer from '@/components/AdvancedFilterDrawer'
import SearchToolbar from '@/components/SearchToolbar'
import { getAKSK, editAKSK, delAKSK } from '@/api/users/aksk'
import { akskStatusOptions } from '@/dataJson/users'
import getTableList from '@/composables/getList' // 获取列表
import useListSearch from '@/composables/useListSearch'
import addAKSK from './addAKSK'
import lookSectet from './lookSecret'
import { useI18n } from 'vue-i18n'
import store from '@/store'
const { t } = useI18n()
const akskStatusOption = akskStatusOptions // aksk状态
// 定义搜索字段
const search = reactive({
  ak: '',
  status: '',
  description: '',
  user_id: ''
})
// 获取列表
const { listData, listTotal, getList, searchFun } = getTableList(search, getAKSK)
const defaultQuickField = 'ak'
const normalizeOptions = (options = []) => {
  return options.map(item => ({
    label: item.label ?? item.name ?? item.display_name ?? '',
    value: item.value ?? item.id ?? ''
  }))
}
const createAKSKSearchFields = () => {
  return {
    ak: {
      key: 'ak',
      label: 'AccessKey',
      filterType: 'filter',
      type: 'input',
      value: '',
      defaultValue: '',
      trim: true,
      placeholder: t('placeholder.search'),
      clearable: true
    },
    status: {
      key: 'status',
      label: t('user.aksk_status'),
      filterType: 'filter',
      type: 'select',
      value: '',
      defaultValue: '',
      options: normalizeOptions([
        { label: t('table.all'), value: '' },
        ...akskStatusOption
      ]),
      placeholder: t('placeholder.choose'),
      clearable: true
    },
    description: {
      key: 'description',
      label: t('user.aksk_description'),
      filterType: 'filter',
      type: 'input',
      value: '',
      defaultValue: '',
      trim: true,
      placeholder: t('placeholder.search'),
      clearable: true
    },
    user_id: {
      key: 'user_id',
      label: t('user.user_id'),
      filterType: 'filter',
      type: 'input',
      value: '',
      defaultValue: '',
      trim: true,
      placeholder: t('placeholder.search'),
      clearable: true
    }
  }
}
const quickSearchFields = computed(() => createAKSKSearchFields())
const advancedFilterButtonText = computed(() => t('table.advancedFilter'))
const {
  searchMode,
  quickSearchField,
  quickSearchValue,
  advancedDrawerVisible,
  filterStr,
  advancedFilterCondition,
  resetAllSearch,
  handleQuickFieldChange,
  handleQuickValueChange,
  handleQuickInput,
  openAdvancedDrawer,
  handleAdvancedSubmit,
  handleAdvancedCancel
} = useListSearch({
  search,
  searchFun,
  quickFields: quickSearchFields,
  defaultQuickField,
  createAdvancedFilterCondition: createAKSKSearchFields
})
const advancedOtherConditionList = computed(() => ({}))
const checkedRows = ref([])
// 添加
const addLayer = ref(false)
const rowData = ref({})
const eidtType = ref('')
const add = () => {
  addLayer.value = true
  eidtType.value = 'create'
}
// 编辑
const editFun = () => {
  rowData.value = checkedRows.value[0]
  addLayer.value = true
  eidtType.value = 'edit'
}
// 查看Secret
const lookLayer = ref(false)
const lookSecretFun = () => {
  rowData.value = checkedRows.value[0]
  lookLayer.value = true
}
// 状态更改
const editeStatusFun = async() => {
  const data = {
    aksk_id: checkedRows.value[0].id,
    update_data: {
      status: checkedRows.value[0].status === 'enabled' ? 'disabled' : 'enabled'
    }
  }
  await editAKSK(data)
  // 获取租户列表
  getList()
}
// 删除
const delFun = async() => {
  await delAKSK({ aksk_id: checkedRows.value[0].id })
  // 获取租户列表
  getList()
}
// table data
const tableData = reactive({
  header: [
    {
      key: 'ak',
      value: 'AccessKey',
      minWidth: '190px',
      sortable: true,
      fixed: 'left'
    },
    {
      key: 'display_roles',
      value: t('user.role'),
      minWidth: '140px',
      sortable: true
    },
    {
      key: 'user_id',
      value: t('user.user_id'),
      minWidth: '190px',
      sortable: true
    },
    {
      key: 'username',
      minWidth: '160px',
      value: t('user.userName'),
      sortable: true
    },
    {
      key: 'display_status',
      value: t('table.status'),
      minWidth: store.state.app.sLanguage === 'en' ? '140px' : '110px',
      sortable: true,
      isShowCircle: true,
      icon: 'status',
      abnormalValue: (row) => row.display_status
    },
    {
      key: 'description',
      minWidth: '190px',
      value: t('user.description'),
      sortable: true
    },
    {
      key: 'created_at',
      minWidth: '170px',
      value: t('table.created_at'),
      sortable: true
    }
  ],
  data: listData,
  total: listTotal
})
</script>

<style lang="scss" scoped>
.operate-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 16px;
}
.operate-group-left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.operate-group-right {
  margin-top: 0 !important;
  margin-left: auto;
  flex-wrap: nowrap !important;
}
.operate-group-right :deep(.search-toolbar) {
  flex-wrap: nowrap;
}
</style>
